import { ROUTES } from 'constants/routes'
import { SITE_TYPE, PAGE_CONTENT_TYPES, SITE_SECTIONS } from './constants'

export const getPageName = ({ pageContentType, pathname, sectionType }) =>
  `${SITE_TYPE}:${pageContentType}:${pathname}:${sectionType}`

export const getPageNameParams = ({ pathname = window.location.pathname, sectionType = '' } = {}) => {
  if (pathname === ROUTES.home.logIn) {
    return {
      pageContentType: PAGE_CONTENT_TYPES.login,
      pathname,
      sectionType: sectionType || SITE_SECTIONS.login,
    }
  }
  if (pathname === ROUTES.home.home) {
    return {
      pageContentType: PAGE_CONTENT_TYPES.home,
      pathname,
      sectionType: sectionType || SITE_SECTIONS.home,
    }
  }
  if (pathname === ROUTES.home.signUp) {
    return {
      pageContentType: PAGE_CONTENT_TYPES.checkout,
      pathname,
      sectionType: sectionType || SITE_SECTIONS.signUp,
    }
  }
  if (pathname === ROUTES.home.contactUs) {
    return {
      pageContentType: PAGE_CONTENT_TYPES.contact,
      pathname,
      sectionType: sectionType || SITE_SECTIONS.contact,
    }
  }
  if (pathname === ROUTES.profile.create) {
    return {
      pageContentType: PAGE_CONTENT_TYPES.checkout,
      pathname,
      sectionType,
    }
  }
  if (pathname === ROUTES.home.confirmEmail.root) {
    return {
      pageContentType: PAGE_CONTENT_TYPES.orderConfirmation,
      pathname,
      sectionType: SITE_SECTIONS.confirmEmail,
    }
  }
  if (
    [
      ROUTES.profile.view,
      ROUTES.profile.changePlan.root,
      ROUTES.profile.settings,
      ROUTES.profile.changePlan.newPlanAccepted,
      ROUTES.profile.renewPlan.root,
      ROUTES.profile.renewPlan.terms,
      ROUTES.profile.renewPlan.accepted,
      ROUTES.profile.enrollPlan.root,
      ROUTES.profile.enrollPlan.terms,
      ROUTES.profile.enrollPlan.accepted,
      ROUTES.profile.enrollPlan.renewAndchangeAccepted,
    ].some(routePath => routePath === pathname)
  ) {
    return {
      pageContentType: PAGE_CONTENT_TYPES.myAccount,
      pathname,
      sectionType: sectionType || SITE_SECTIONS.myAccount,
    }
  }
  if (pathname === ROUTES.home.forgotPassword) {
    return {
      pageContentType: PAGE_CONTENT_TYPES.forgotPassword,
      pathname,
      sectionType: sectionType || SITE_SECTIONS.forgotPassword,
    }
  }

  return {
    pageContentType: '',
    pathname,
    sectionType,
  }
}

export const getFirstOrSecondCreator = predicate => (first, second = '') => {
  return predicate ? first : second
}

export const getNormalizedStringValue = (value = '') => value.toLowerCase().replace(' ', '_')
